module.exports = __webpack_public_path__ + "static/media/electrical.f86b32a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/electrical.svg
// module id = 271
// module chunks = 0